import React from "react";
import PrefilledDot from "@/components/post-ad/PrefilledDot";

/**
 * Uppercase-labeled form field used across every post-ad section. Kept as a
 * plain wrapper (label + span) — deliberately simple so consumers control
 * their own inputs and inline validation.
 *
 * `prefilled` (Iter-253): when true, appends a small green dot next to
 * the label to signal the value was auto-filled by the plate lookup.
 */
export default function Field({ label, children, prefilled = false }) {
  return (
    <label className="block">
      <span className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400 mb-1.5 block">
        {label}
        {prefilled && <PrefilledDot />}
      </span>
      {children}
    </label>
  );
}
